module.exports = __webpack_public_path__ + "static/img/contact_logo3.d0cf573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo3.png
// module id = wrPn
// module chunks = 1